<template>
  <div class="w-full flex flex-col items-center pt-16">
    <div class="w-[94%] md:w-[75%] 2xl:w-[60%]">
      <h2 class="text-3xl font-semibold text-mainColor">Working Shift</h2>
      <p class="pt-3 font-semibold">
        Our clients are able to choose the best work shift hours to meet your
        requirement.<br />
        KFS's standard shift hours are as below:
      </p>
      <p class="pt-3">Eight (8) Hour Shift Operation</p>
      <p class="pt-3">Twelve (12) Hour Shift Operation</p>

      <div class="flex justify-between items-start pt-10">
        <!-- Left Column -->
        <div class="space-y-3">
          <div class="flex rounded overflow-hidden shadow border border-gray-300">
            <span
              class="bg-yellow-500 text-black px-4 py-2 font-medium flex items-center gap-2"
            >
              <i class="pi pi-clock"></i>A. Shift
            </span>
            <span class="bg-gray-800 text-white px-4 py-2">06:00 to 14:00 hours</span>
          </div>
          <div class="flex rounded overflow-hidden shadow border border-gray-300">
            <span
              class="bg-yellow-500 text-black px-4 py-2 font-medium flex items-center gap-2"
            >
              <i class="pi pi-clock"></i>B. Shift
            </span>
            <span class="bg-gray-800 text-white px-4 py-2">14:00 to 22:00 hours</span>
          </div>
          <div class="flex rounded overflow-hidden shadow border border-gray-300">
            <span
              class="bg-yellow-500 text-black px-4 py-2 font-medium flex items-center gap-2"
            >
              <i class="pi pi-clock"></i>C. Shift
            </span>
            <span class="bg-gray-800 text-white px-4 py-2">22:00 to 06:00 hours</span>
          </div>
        </div>

        <!-- Middle Column -->
        <div class="space-y-3">
          <div class="flex rounded overflow-hidden shadow border border-gray-300">
            <span
              class="bg-yellow-500 text-black px-4 py-2 font-medium flex items-center gap-2"
            >
              <i class="pi pi-clock"></i>D. Shift
            </span>
            <span class="bg-gray-800 text-white px-4 py-2">06:00 to 18:00 hours</span>
          </div>
          <div class="flex rounded overflow-hidden shadow border border-gray-300">
            <span
              class="bg-yellow-500 text-black px-4 py-2 font-medium flex items-center gap-2"
            >
              <i class="pi pi-clock"></i>E. Shift
            </span>
            <span class="bg-gray-800 text-white px-4 py-2">18:00 to 06:00 hours</span>
          </div>
        </div>

        <!-- Right Column -->
        <div class="flex flex-col items-center">
          <img src="../../assets/images/24h.jpg" alt="24/7 service" class="w-40" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuardingWorkingShiftContent",
};
</script>
